/** Mirrors `classNamesFor('SidebarItem')` — DS utils are not in the public package exports. */
const root = 'Ds-SidebarItem';

export const sidebarItemClassNames = {
  root,
  link: `${root}-Link`,
  leading: `${root}-Leading`,
  icon: `${root}-Icon`,
  label: `${root}-Label`,
  trailing: `${root}-Trailing`,
};
